const isCastApiAvailable = () => {
   return (
      typeof window !== 'undefined' &&
      typeof window.cast !== 'undefined' &&
      typeof window.chrome !== 'undefined' &&
      typeof window.chrome.cast !== 'undefined'
   );
};

const getCastAvailabilityDetails = () => {
   const windowDefined = typeof window !== 'undefined';
   const castDefined = windowDefined && typeof window.cast !== 'undefined';
   const chromeDefined = windowDefined && typeof window.chrome !== 'undefined';
   const chromeCastDefined = chromeDefined && typeof window.chrome.cast !== 'undefined';

   return {
      available: isCastApiAvailable(),
      windowDefined,
      castDefined,
      chromeDefined,
      chromeCastDefined,
   };
};

const getCastState = () => {
   if (!isCastApiAvailable()) {
      return null;
   }

   try {
      return window.cast.framework.CastContext.getInstance().getCastState();
   } catch {
      return null;
   }
};

export { isCastApiAvailable, getCastAvailabilityDetails, getCastState };
